angular.module('impactx.contentdashboard').controller('ContentDashboardCtrl', [ContentDashboardCtrl]);

function ContentDashboardCtrl() {
}
